import type { FingerNumbersDisplay } from 'Seeds/ExerciseContent/scaleFingering';
import { createPerUserDeviceStore } from 'Settings/perUserDeviceStore';
import { normalizeFingerNumbersDisplay } from './scaleFingerNumbersSettings';

/**
 * The setting lives in the per-user namespace of the app's persisted storage
 * (`<user id>-museflow_scale_finger_numbers`), like the key-signature display setting: a
 * device preference each account keeps, carried through sign-out's storage clear.
 */
export const SCALE_FINGER_NUMBERS_STORAGE_KEY = 'museflow_scale_finger_numbers';

export const scaleFingerNumbersStore = createPerUserDeviceStore<FingerNumbersDisplay>({
  storageKey: SCALE_FINGER_NUMBERS_STORAGE_KEY,
  decode: normalizeFingerNumbersDisplay,
  encode: (display) => display,
  errorTag: 'scaleFingerNumbers.load',
});

/** Whether a full storage key (any user prefix included) holds the setting. */
export const isScaleFingerNumbersStorageKey = scaleFingerNumbersStore.isStorageKey;
